var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "130px",
    height: "130px",
    viewBox: "0 0 130 130",
    style: {
      enableBackground: "new 0 0 130 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st2{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M120.6357803,62.8467484v33.2600021c0,2.5299988-0.3699951,4.9599991-1.0699997,7.2599945H10.4257822 c-0.6999998-2.2999954-1.0700006-4.7299957-1.0700006-7.2599945V62.8467484H120.6357803z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.6357803,50.456749v12.3899994H9.3557816V33.8867493 c0-13.8800011,11.25-25.1300011,25.1399994-25.1300011h45.1699982l0.0699997,0.0699997 c-0.3899994,2.0900002-0.5899963,4.25-0.5899963,6.4499998c0,19.5699997,15.8600006,35.4399986,35.4400024,35.4399986 c1.9899979,0,3.9300003-0.1599998,5.8299942-0.4799995h0.0100021L120.6357803,50.456749z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7357788,8.8267479l40.6800003,41.4099998c-1.8999939,0.3199997-3.8399963,0.4799995-5.8299942,0.4799995 c-19.5800018,0-35.4400024-15.8699989-35.4400024-35.4399986C79.1457825,13.0767479,79.3457794,10.916748,79.7357788,8.8267479 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.4257822,103.366745h109.1399994c-3.1100006,10.3500061-12.7099991,17.8800049-24.0699997,17.8800049 h-61C23.1357822,121.2467499,13.5357819,113.7167511,10.4257822,103.366745z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.4157791,50.2367477L79.7357788,8.8267479l-0.0699997-0.0699997H34.4957809 c-13.8899994,0-25.1399994,11.25-25.1399994,25.1300011v28.9599991v33.2600021 c0,2.5299988,0.3700008,4.9599991,1.0700006,7.2599945c3.1099997,10.3500061,12.71,17.8800049,24.0699997,17.8800049h61 c11.3600006,0,20.9599991-7.5299988,24.0699997-17.8800049c0.7000046-2.2999954,1.0699997-4.7299957,1.0699997-7.2599945 V62.8467484V50.456749l-0.2099991-0.2200012"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 9.3557816,
    y1: 62.8467484,
    x2: 120.6357803,
    y2: 62.8467484
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 10.4257822,
    y1: 103.366745,
    x2: 119.5657806,
    y2: 103.366745
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.4257812,50.2367477h-0.0100021c-1.8999939,0.3199997-3.8399963,0.4799995-5.8299942,0.4799995 c-19.5800018,0-35.4400024-15.8699989-35.4400024-35.4399986c0-2.1999998,0.1999969-4.3599997,0.5899963-6.4499998 c0-0.0199995,0.0100021-0.04,0.0100021-0.0599995"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.7461548,8.7650528"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.684494,70.5289764h8.9575195c6.0092773,0,9.0322266,2.7988281,9.0322266,7.875 c0,5.3369141-3.3964844,8.1367188-8.7333984,8.1367188h-4.6655273v9.5917969H32.684494V70.5289764z M41.0824432,83.1071014 c3.4711914,0,4.7773438-1.4560547,4.7773438-4.4414062c0-3.359375-1.3061523-4.5908203-4.7026367-4.5908203h-3.8818359v9.0322266 H41.0824432z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.9252167,70.5289764h8.3979492c7.8378906,0,12.2416992,3.7695312,12.2416992,12.1298828v0.7460938 c0,8.2119141-3.9931641,12.7275391-12.2045898,12.7275391h-8.4350586V70.5289764z M63.3978729,92.5123749 c5.0009766,0,7.3154297-2.4638672,7.3154297-8.6591797v-1.2314453c0-6.4570312-2.7993164-8.4726562-7.6513672-8.4726562H59.516037 v18.3632812H63.3978729z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.3002167,70.5289764h15.7133789v3.6201172H84.891037v7.6513672h8.6591797v3.5458984H84.891037v10.7861328 h-4.5908203V70.5289764z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.7f0663bd957d10a8acc7cfeddb28ae6e.svg";
export { ForwardRef as ReactComponent };